<template>
  <div class="margin-subpages" id="power_skill_page">
    <el-select
      v-model="selectTeam"
      filterable
      placeholder="Select"
      class="input-style"
      @change="handleTeams"
      :class="[ blurMode ?  'blurelement': '' ]"
    >
      <el-option
        v-if="user.user_type !== 'leadership'"
        class="text-dropdown"
        key="all"
        :label="`All Teams (${$utils(
          'addCommasInNumber',
          optionsTeam.length
        )})`"
        value="all"
      ></el-option>
      <el-option
        class="text-dropdown"
        v-for="item in optionsTeam"
        :key="item.key"
        :label="item.name"
        :value="item.key"
        :class="[ blurMode ?  'blurelement': '' ]"
      ></el-option>
    </el-select>
    <div id="byManager">
      <div class="mt-30 fs-18 fw-700">Power Skills Progress & Ratings</div>
      <div class="fc-747474 fs-13 mt-6">
        The overall effort score for practicing each skill with a rating trend and leaderboard from the past 6-months
      </div>
    </div>
    <div class="mt-32"></div>
    <el-collapse v-model="activeName">
      <el-collapse-item
        v-for="(skill, index) in pageData"
        :key="index + '_' + skill.title"
        :name="skill.title"
      >
        <template slot="title">
          <div class="relative flex-cemter title-custom">
            <div
              class="score-bar"
              :style="`background: ${skill.primaryColor}; width: ${skill.score}%;}`"
            ></div>
            <div class="flex-center ml-18 mr-14" style="z-index: 2">
              <img
                :class="`${
                  activeName.includes(skill.title) ? 'rolate' : ''
                } image-expand`"
                :src="$utils('icons', 'ic_expand_24dp')"
                alt="icons_ic_expand_24dp"
              />
            </div>
            <div v-if="skill.title" class="relative" style="width: 48px">
              <img
                class="icon absolute-mid"
                :src="getImgIconOfPower(skill.title)"
                :alt="skill.title"
              />
            </div>
            <div class="label fw-700 ml-4 mr-auto">{{ skill.title }}</div>
            <div class="label ml-auto mr-15">{{ skill.score }}%</div>
          </div>
        </template>
        <div class="fs-16 skill-body">
          <div
            class="chart-container"
            :style="`background: ${skill.primaryColor}0A;`"
          >
            <div class="flex-center chart-title">
              <div
                class="box-color"
                :style="`background: ${skill.primaryColor};`"
              ></div>
              {{ selectTeam == "all" ? "All Teams" : teamsAll[selectTeam].name }}
              <div
                class="box-color ml-16"
                :style="`background: ${skill.secondaryColor};`"
              ></div>
              Company Avg.
            </div>
            <div>
              <div class="bar-chart-conainter-style ">
                <div class="relative" style="z-index: 99; height: 134px">
                  <canvas
                    :ref="skill.title + '_bar_chart'"
                    height="120px"
                    class="barchart-style"
                  ></canvas>
                </div>
                <div class="line-dashed"></div>
              </div>
              <div
                :style="`height: 150px; border-radius: 6px; background: ${skill.primaryColor}0A; padding: 24px 54px`"
              >
                <canvas
                  :ref="skill.title + '_line_chart'"
                  height="150px"
                  class="linechart-style"
                ></canvas>
              </div>
            </div>
          </div>
          <div class="flex-center mt-16 mb-12">
            <div class="fs-14 fw-700" :style="`color: ${skill.primaryColor};`">
              LEADERBOARD
            </div>
            <div class="ml-auto flex-center">
              <div class="fs-14 mr-16">Sort by</div>
              <div style="width: 220px">
                <el-menu class="input-select" mode="horizontal">
                  <el-submenu index="0" style="width: 220px">
                    <template slot="title">
                      <span class="text-dropdown">
                        {{ selectSort ? selectSort : "All" }}
                      </span>
                    </template>
                    <el-menu-item
                      @click="sortingClick('Ascending Rating',index)"
                      index="1"
                      style="font-size: 14px; width: 220px"
                      >Ascending Rating</el-menu-item
                    >
                    <el-menu-item
                      @click="sortingClick('Ascending Score',index)"
                      index="1"
                      style="font-size: 14px; width: 220px"
                      >Ascending Score</el-menu-item
                    >
                    <el-menu-item
                      @click="sortingClick('Descending Rating',index)"
                      index="1"
                      style="font-size: 14px; width: 220px"
                      >Descending Rating</el-menu-item
                    >
                    <el-menu-item
                      @click="sortingClick('Descending Score',index)"
                      index="1"
                      style="font-size: 14px; width: 220px"
                      >Descending Score</el-menu-item
                    >
                  </el-submenu>
                </el-menu>
              </div>
            </div>
          </div>
          <div class="leaderboard-conainter">
            <div
              v-for="(member, i2) in reranderArrayForShowing(
                skill.Leaderboards
              )"
              :key="i2 + '_profile_' + skill.title"
              class="member-card flex-center relative"
            >
              <div class="index">{{ member.index + 1 }}</div>
              <div v-if="member.imageProfile">
                <img
                  v-lazy="member.imageProfile"
                  :key="member.imageProfile"
                  class="image-skeleton image-profile-32"
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
              </div>
              <div v-else class="image image-profile-32"
              :class="[ blurMode ?  'blurelement': '' ]">
                <div class="text-in-image text-in-image-42 flex-mid">
                  {{
                    $utils("acronymName", {
                      fullName: member.name,
                    })
                  }}
                </div>
              </div>
              <div class="label-member">
                <div class="name ellipsis"
                :class="[ blurMode ?  'blurelement': '' ]">{{ member.name }}</div>
                <div class="team-name ellipsis"
                :class="[ blurMode ?  'blurelement': '' ]">{{ member.teamname }}</div>
              </div>
              <div class="scorenum-label" :style="`color: ${skill.primaryColor};`">
                {{ $utils("addCommasInNumber", member.score) }}
              </div>
              <div class="rate-label ml-auto mr-4">{{ member.rating }}</div>
              <div class="flex-mid">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="star_black_24dp"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  class="pb-2"
                >
                  <g id="Group_13402" data-name="Group 13402">
                    <path
                      id="Path_5306"
                      data-name="Path 5306"
                      d="M0,0H16V16H0Z"
                      fill="none"
                    />
                    <path
                      id="Path_5307"
                      data-name="Path 5307"
                      d="M0,0H16V16H0Z"
                      fill="none"
                    />
                  </g>
                  <g
                    id="Group_13403"
                    data-name="Group 13403"
                    transform="translate(2.295 2.382)"
                    :fill="skill.primaryColor"
                  >
                    <path
                      id="Path_5308"
                      data-name="Path 5308"
                      d="M9.148,12.7l2.767,1.673a.665.665,0,0,0,.993-.72l-.733-3.147,2.447-2.12a.665.665,0,0,0-.38-1.167l-3.22-.273L9.761,3.978a.667.667,0,0,0-1.227,0L7.274,6.944l-3.22.273a.665.665,0,0,0-.38,1.167L6.121,10.5l-.733,3.147a.665.665,0,0,0,.993.72Z"
                      transform="translate(-3.443 -3.573)"
                    />
                  </g>
                </svg>
              </div>
              <div
                class="rating-bar"
                :style="`background: ${skill.primaryColor}; width: ${member.bar}%;`"
              ></div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "power-skills",
  components: {
    loadingEven: require("../even/loading").default,
  },
  created() {
    this.$store.dispatch("team/getTeamsOptionsFixed", this.user);
    this.$store.dispatch("powerSkill/getOrganization1level");
  },

  watch: {
    optionsTeam() {
      if (this.optionsTeam.length > 0) {
        this.selectTeam =
          this.user.user_type == "leadership" ? this.user.team : "all";
      }
    },
    selectTeam() {
      this.$store.dispatch("insightsManagers/setTeamSorting", this.selectTeam);
    },
    pageData() {
      setTimeout(() => {
        if (this.myChart.ps_critical_thinking) this.myChart.ps_critical_thinking.destroy(); 
        if (this.myChart.ps_empathy) this.myChart.ps_empathy.destroy();
        if (this.myChart.ps_initiative_making) this.myChart.ps_initiative_making.destroy();
        if (this.myChart.ps_leadership) this.myChart.ps_leadership.destroy();
        if (this.myChart.ps_optimism) this.myChart.ps_optimism.destroy();
        if (this.myChart.ps_self_awareness) this.myChart.ps_self_awareness.destroy();

        if (this.lineChart.ps_critical_thinking) this.lineChart.ps_critical_thinking.destroy(); 
        if (this.lineChart.ps_empathy) this.lineChart.ps_empathy.destroy();
        if (this.lineChart.ps_initiative_making) this.lineChart.ps_initiative_making.destroy();
        if (this.lineChart.ps_leadership) this.lineChart.ps_leadership.destroy();
        if (this.lineChart.ps_optimism) this.lineChart.ps_optimism.destroy();
        if (this.lineChart.ps_self_awareness) this.lineChart.ps_self_awareness.destroy();
        this.randerBarChart(this.pageData);
        this.activeName.push(this.pageData[0].title)
      }, 300);
    },
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    optionsTeam() {
      return this.$store.getters["team/teamsfixedall"];
    },
    pageData () {
      
      return this.$store.getters["powerSkill/pageData"];
    },
    teamsAll(){
      return this.$store.getters["powerSkill/teamsAll"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
   
  },
  data() {
    return {
      selectTeam: "",
      activeName: [""],
      mappingData: [
        {
          title: "Empathy",
          icon: "ic_empathy",
          primaryColor: "#6000DA",
          secondaryColor: "#C8B0E6",
        },
        {
          title: "Self Awareness",
          icon: "ic_selfawareness",
          primaryColor: "#f77511",
          secondaryColor: "#FFD3B1",
        },
        {
          title: "Critical Thinking",
          icon: "ic_criticalthinking",
          primaryColor: "#ff2b19",
          secondaryColor: "#FFCCC7",
        },
        {
          title: "Leadership",
          icon: "ic_leadership",
          primaryColor: "#00AA1A",
          secondaryColor: "#CBFFD3",
        },
        {
          title: "Initiative Making",
          icon: "ic_initiative",
          primaryColor: "#8CE100",
          secondaryColor: "#DBFCA5",
        },
        {
          title: "Optimism",
          icon: "ic_optimism",
          primaryColor: "#F2D222",
          secondaryColor: "#F8E88B",
        },
      
      ],
      myChart:{
        ps_critical_thinking:'',
        ps_empathy:'',
        ps_initiative_making:'',
        ps_leadership:'',
        ps_optimism:'',
        ps_self_awareness:''
      },
      lineChart:{
        ps_critical_thinking:'',
        ps_empathy:'',
        ps_initiative_making:'',
        ps_leadership:'',
        ps_optimism:'',
        ps_self_awareness:''
      },
      // pageData: [
      //   {
      //     title: "Self-Awareness",
      //     score: 91,
      //     primaryColor: "#f77511",
      //     secondaryColor: "#FFD3B1",
      //     chartReader: null, // keep null
          // barChartData: {
          //   labels: [
          //     "Oct",
          //     "Nov",
          //     "Dec",
          //     "Jan",
          //     "Feb",
          //     "Mar",
          //     "Apr",
          //     "May",
          //     "Jun",
          //   ],
          //   datasets: [
          //     {
          //       label: "TeamName",
          //       data: [0, 10, 5, 2, 20, 30, 45, 50, 85],
          //     },
          //     {
          //       label: "Company Avg.",
          //       data: [0, 10, 5, 2, 20, 30, 45, 50, 85],
          //     },
          //   ],
          // },
          // lineChartData: {
          //   labels: [
          //     "Oct",
          //     "Nov",
          //     "Dec",
          //     "Jan",
          //     "Feb",
          //     "Mar",
          //     "Apr",
          //     "May",
          //     "Jun",
          //   ],
          //   datasets: [
          //     {
          //       label: "Rating",
          //       data: [2.7, 2.8, 2.9, 3.0, 3.1, 3.2, 3.4, 3.5, 3.6],
          //     },
          //   ],
          // },
          // Leaderboards: [
          //   {
          //     name: "John Doe1",
          //     id: "john-doe",
          //     teamname: "Team 1",
          //     imageProfile: "",
          //     rating: 4.8,
          //     score: 2417,
          //   },
          //   {
          //     name: "John Doe2",
          //     id: "john-doe",
          //     teamname: "Team 1",
          //     imageProfile: "",
          //     rating: 4.6,
          //     score: 2017,
          //   },
          //   {
          //     name: "John Doe3",
          //     id: "john-doe",
          //     teamname: "Team 1",
          //     imageProfile: "",
          //     rating: 4.3,
          //     score: 1917,
          //   },
          //   {
          //     name: "John Doe4",
          //     id: "john-doe",
          //     teamname: "Team 1",
          //     imageProfile: "",
          //     rating: 2.1,
          //     score: 1617,
          //   },
          //   {
          //     name: "John Doe5",
          //     id: "john-doe",
          //     teamname: "Team 1",
          //     imageProfile: "",
          //     rating: 1.4,
          //     score: 1417,
          //   },
          // ],
      //   },
      //   {
      //     title: "Empathy",
      //     score: 85,
      //     primaryColor: "#6000DA",
      //     secondaryColor: "#D0B9F5",
      //     chartReader: null, // keep null
      //     barChartData: {
      //       labels: [
      //         "Oct",
      //         "Nov",
      //         "Dec",
      //         "Jan",
      //         "Feb",
      //         "Mar",
      //         "Apr",
      //         "May",
      //         "Jun",
      //       ],
      //       datasets: [
      //         {
      //           label: "TeamName",
      //           data: [0, 10, 5, 2, 20, 30, 45, 50, 85],
      //         },
      //         {
      //           label: "Company Avg.",
      //           data: [0, 10, 5, 2, 20, 30, 45, 50, 85],
      //         },
      //       ],
      //     },
      //     lineChartData: {
      //       labels: [
      //         "Oct",
      //         "Nov",
      //         "Dec",
      //         "Jan",
      //         "Feb",
      //         "Mar",
      //         "Apr",
      //         "May",
      //         "Jun",
      //       ],
      //       datasets: [
      //         {
      //           label: "Rating",
      //           data: [2.7, 2.8, 2.9, 3.0, 3.1, 3.2, 3.4, 3.5, 3.6],
      //         },
      //       ],
      //     },
      //     Leaderboards: [
      //       {
      //         name: "John Doe1",
      //         id: "john-doe",
      //         teamname: "Team 1",
      //         imageProfile: "",
      //         rating: 4.8,
      //         score: 2417,
      //       },
      //       {
      //         name: "John Doe2",
      //         id: "john-doe",
      //         teamname: "Team 1",
      //         imageProfile: "",
      //         rating: 4.6,
      //         score: 2017,
      //       },
      //       {
      //         name: "John Doe3",
      //         id: "john-doe",
      //         teamname: "Team 1",
      //         imageProfile: "",
      //         rating: 4.3,
      //         score: 1917,
      //       },
      //       {
      //         name: "John Doe4",
      //         id: "john-doe",
      //         teamname: "Team 1",
      //         imageProfile: "",
      //         rating: 2.1,
      //         score: 1617,
      //       },
      //       {
      //         name: "John Doe5",
      //         id: "john-doe",
      //         teamname: "Team 1",
      //         imageProfile: "",
      //         rating: 1.4,
      //         score: 1417,
      //       },
      //     ],
      //   },
      // ],
      selectSort: "Descending Score",
    };
  },
  mounted() {
    if (this.optionsTeam.length > 0 && this.selectTeam == "") {
      this.selectTeam =
        this.user.user_type == "leadership" ? this.user.team : "all";
    }
    // TODO: get data from api
    setTimeout(() => {
      this.randerBarChart(this.pageData);
      this.activeName.push(this.pageData[0]&&this.pageData[0].title?this.pageData[0].title:'')
    }, 2000);
  },
  methods: {
    handleTeams(key) {
      this.selectTeam = key;
      // console.log("Here handleTeams", key);
      this.$store.dispatch("powerSkill/getData",key);
    },
    mappingDataFuc(name) {
      const data = this.mappingData.find((item) => item.title == name);
      return data || {};
    },
    getImgIconOfPower(name) {
      const data = this.mappingDataFuc(name);
      return require("@/assets/images/components/profile/" +
        data.icon +
        ".png");
    },
    reranderArrayForShowing(data) {
      const evenArr = [];
      const oddArr = [];

      // Split the array into even and odd elements
      for (let i = 0; i < data.length; i++) {
        const item = { index: i, ...data[i] };

        if (i % 2 === 0) {
          evenArr.push(item);
        } else {
          oddArr.push(item);
        }
      }

      // Combine the even and odd arrays in the desired pattern
      const result = [];
      const maxLength = Math.max(evenArr.length, oddArr.length);

      for (let i = 0; i < maxLength; i++) {
        if (i < evenArr.length) {
          result.push(evenArr[i]);
        }
        if (i < oddArr.length) {
          result.push(oddArr[i]);
        }
      }

      return result;
    },
    randerBarChart(data) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
 
        this.randerBarChartItem(item);
        this.randerLineChartItem(item);
      }
    },
    randerBarChartItem(item) {
      
      var barchart = this.$refs[item.title + "_bar_chart"];
      if (barchart[0]) {
        
        this.loadingChartStatus = false;
        const townHallChartData = {
          labels: item.barChartData.labels,
          datasets: [
            {
              label: item.barChartData.datasets[1].label,
              data: item.barChartData.datasets[1].data,
              backgroundColor: item.secondaryColor,
              borderColor: item.secondaryColor,
              borderWidth: 1,
            },
            {
              label: item.barChartData.datasets[0].label,
              data: item.barChartData.datasets[0].data,
              backgroundColor: item.primaryColor,
              borderColor: item.primaryColor,
              borderWidth: 1,
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.plugins.tooltip = {
          enabled: false,
        };
        options.scales = {
          y: {
            display: false,
          },
          x: {
            grid: {
              display: false,
            },
          },
        };
        options.title = {
          display: true,
        };
        options.animation = {
            duration: 0,
        };
        options.datasets = {
          bar: {
            categoryPercentage: 0.5,
            borderRadius: 3,
            borderSkipped: true,
          },
        };
        this.myChart[item.id] = new Chart(barchart[0].getContext("2d"), {
          type: "bar",
          data: townHallChartData,
          options: options,
        });
       
      }
    },
    randerLineChartItem(item) {
     
      var barchart = this.$refs[item.title + "_line_chart"];
      if (barchart[0]) {
        this.loadingChartStatus = false;
        
        // Instead of filtering out zero values, replace them with null
        // This maintains alignment with the bar chart while skipping the line drawing
        const dataPoints = [...item.lineChartData.datasets[0].data];
        for (let i = 0; i < dataPoints.length; i++) {
          if (dataPoints[i] === 0 || dataPoints[i] === undefined) {
            dataPoints[i] = null;
          }
        }
        
        const townHallChartData = {
          labels: item.lineChartData.labels,
          datasets: [
            {
              label: item.lineChartData.datasets[0].label,
              data: dataPoints,
              backgroundColor: item.primaryColor,
              borderColor: item.primaryColor,
              borderDash: [3, 2],
              borderWidth: 1,
              spanGaps: true, // Skip null data points when drawing the line
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.plugins.tooltip = {
          enabled: false,
        };
        options.scales = {
          y: {
            display: false,
          },
          x: {
            display: false,
          },
        };
        options.layout = {
          padding: {
            left: 30,
            right: 10,
            top: 20
          },
        };
        options.animation = {
            duration: 0,
        };
        options.plugins.datalabels = {
          color: item.primaryColor,
          font: {
            weight: "bold",
            size: 12,
          },
          anchor: "end",
          clamp: true,
          align: "top",
          offset: 2,
          // Skip rendering labels for null data points
          formatter: function(value) {
            return value !== null ? value : '';
          }
        };
        this.lineChart[item.id]= new Chart(barchart[0].getContext("2d"), {
          type: "line",
          data: townHallChartData,
          options: options,
          plugins: [ChartDataLabels],
        });
      }
    },
    sortingClick(status,index) {
      // console.log("Here sortingClick", index)
      this.selectSort = status;
      this.$store.dispatch("powerSkill/sortData",{sort:status,index:index});
    },
  },
};
</script>

<style lang="scss" scoped>
.title-custom {
  display: flex;
  justify-content: space-between;
  color: #fff;
  width: 100%;

  .image-expand {
    width: 20px;
    height: 20px;
    transition: 0.3s;
    transform: rotate(0deg);
  }
  .image-expand.rolate {
    transform: rotate(180deg);
  }

  .score-bar {
    position: absolute;
    left: 0;
    border-radius: 6px;
    height: 100%;
    box-shadow: 0px 1px 6px #00000014;
  }

  .label {
    font-size: 14px;
    font-weight: 700;
    z-index: 2;
  }
}

.skill-body {
  .chart-container {
    position: relative;
    height: 366px;
    width: calc(100% - 40px);
    padding: 15px 20px 28px;
    margin-top: 4px;
    border-radius: 24px;

    .chart-title {
      font-size: 12px;
      font-weight: 700;

      .box-color {
        height: 16px;
        width: 16px;
        border-radius: 3px;
        margin-right: 8px;
      }
    }
  }
}

.leaderboard-conainter {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(5, 64px);
  gap: 6px 32px;
  padding-right: 20px;
  grid-auto-flow: column;
  list-style: none;

  .member-card {
    height: 64px;
    padding: 0 24px 0 16px;
    border: 1px solid #dddddd;
    border-width: 1px;
    border-radius: 6px;
    overflow: hidden;

    .index {
      color: #0000004d;
      font-size: 14px;
      font-weight: 700;
      width: 24px;
      padding-top: 2px;
    }

    .label-member {
      line-height: 16px;
      width: 190px;
      margin-left: 12px;
    }

    .name {
      color: #000;
      font-size: 14px;
      font-weight: 700;
    }

    .team-name {
      color: #000;
      font-size: 13px;
    }

    .scorenum-label {
      font-size: 16px;
      font-weight: 700;
      width: 66px;
      text-align: right;
      margin-right: 12px;
    }
    .rate-label {
      font-size: 16px;
      font-weight: 700;
    }
    .rating-bar {
      height: 4px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
.bar-chart-conainter-style {
  padding: 12px 24px;
  position: relative;
  .line-dashed {
    content: "";
    position: absolute;
    top: 48px;
    left: 24px;
    width: calc(100% - 48px);
    height: 36px;
    opacity: 0.5;
    border: 1px dashed #dddddd;
    border-width: 1px 0;
  }
}
</style>

<style lang="scss">
#power_skill_page {
  .el-collapse-item__header {
    background-color: #cccccc;
    border: 0;
    border-radius: 6px;
    box-shadow: 0px 1px 6px #00000014;
    margin-bottom: 12px;
  }

  .el-collapse-item__arrow {
    display: none;
  }

  .el-collapse,
  .el-collapse-item__wrap {
    border: 0;
  }
}
</style>
